import axios from 'axios';

import { apiClient } from './config';
import { buildApiUrl } from '../utils/media';

function get(path, config) {
  return apiClient.get(path, config);
}

function post(path, data, config) {
  return apiClient.post(path, data, config);
}

function put(path, data, config) {
  return apiClient.put(path, data, config);
}

function del(path, config) {
  return apiClient.delete(path, config);
}

function absoluteGet(path, config) {
  return axios.get(buildApiUrl(path), config);
}

function absolutePost(path, data, config) {
  return axios.post(buildApiUrl(path), data, config);
}

function absolutePut(path, data, config) {
  return axios.put(buildApiUrl(path), data, config);
}

function absoluteDelete(path, config) {
  return axios.delete(buildApiUrl(path), config);
}

export const authApi = {
  getCurrentUser() {
    return get('/api/auth/me');
  },
  login(credentials) {
    return post('/api/auth/login', credentials);
  },
  logout() {
    return post('/api/auth/logout', {});
  },
};

export const productsApi = {
  getAll() {
    return get('/api/products');
  },
  getFeatured() {
    return get('/api/products?featured=true');
  },
  getBySlug(slug) {
    return get(`/api/products/${slug}`);
  },
  getCategories() {
    return get('/api/categories');
  },
  getAllForAdmin() {
    return absoluteGet('/api/products?active_only=false');
  },
  create(data) {
    return absolutePost('/api/admin/products', data);
  },
  update(productId, data) {
    return absolutePut(`/api/admin/products/${productId}`, data);
  },
  remove(productId) {
    return absoluteDelete(`/api/admin/products/${productId}`);
  },
};

export const settingsApi = {
  getPublic() {
    return get('/api/settings');
  },
  getAdmin() {
    return absoluteGet('/api/admin/settings');
  },
  update(settings) {
    return absolutePut('/api/admin/settings', settings);
  },
};

export const cmsApi = {
  getAll() {
    return get('/api/cms');
  },
  getSection(section) {
    return get(`/api/cms/${section}`);
  },
  getAllForAdmin() {
    return absoluteGet('/api/cms');
  },
  update(cms) {
    return absolutePut('/api/admin/cms', cms);
  },
};

export const ordersApi = {
  create(data) {
    return post('/api/orders', data);
  },
  getAdminOrders() {
    return absoluteGet('/api/admin/orders');
  },
  updateStatus(orderId, status) {
    return absolutePut(`/api/orders/${orderId}/status?status=${status}`, {});
  },
};

export const customOrdersApi = {
  estimate(data) {
    return post('/api/custom-orders/estimate', data);
  },
  create(data) {
    return post('/api/custom-orders', data);
  },
  getAdminOrders() {
    return absoluteGet('/api/admin/custom-orders');
  },
  updateStatus(orderId, status) {
    return absolutePut(`/api/admin/custom-orders/${orderId}/status?status=${status}`, {});
  },
};

export const uploadsApi = {
  uploadPublic(file) {
    const formData = new FormData();
    formData.append('file', file);
    return post('/api/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  async uploadAdmin(file) {
    const formData = new FormData();
    formData.append('file', file);
    const response = await absolutePost('/api/admin/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    if (response?.data?.url) {
      response.data.url = buildApiUrl(response.data.url);
    }
    return response;
  },
};
